import React from 'react'
import cssModules from 'react-css-modules'
import { PropTypes } from 'prop-types'
import styles from './charity_details_modal.less'
import { Sheet, HeadingText, BodyText, Row } from '@paypalcorp/pp-react'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/crowdfunding_charity_detail_view')
const US = 'US'

class CharityDetailsModal extends React.Component {
  static propTypes = {
    onGivingFundTermsModalClose: PropTypes.function,
    showGivingFundTermsModal: PropTypes.bool,
    countryCode: PropTypes.string,
    cdnHost: PropTypes.string,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { countryCode, cdnHost } = this.props
    const IconUrl = `https://${cdnHost}/images/Cause/hub/ic_blueheart.svg`
    const isCountryCodeUS = countryCode === US

    return (
      <Sheet
        isOpen={this.props.showGivingFundTermsModal}
        onClose={this.props.onGivingFundTermsModalClose}
        noPadding="true"
      >
        <article styleName="charity-modal-content">
          <Row noGutters="true" align="center" styleName="charity-heart-image">
            <img src={IconUrl} alt="charity paypal heart" />
          </Row>

          <Row noGutters="true" align="center" styleName="margin-bottom-24">
            <HeadingText>{i18n('powered_by')}</HeadingText>
          </Row>

          <Row noGutters="true" styleName="margin-bottom-24">
            <BodyText>{i18n('secure_funds')}</BodyText>
          </Row>

          <Row noGutters="true" styleName="charity-modal-content-header">
            <BodyText strong="true">{i18n('how_it_works')}</BodyText>
          </Row>

          <Row noGutters="true">
            <BodyText styleName="charity-details-modal-body">
              <ol>
                <li>{i18n('charity_donation_process_step1')}</li>

                <li>{i18n(`charity_donation_process_step2_${countryCode}`)}</li>

                <li>{i18n('charity_donation_process_step3')}</li>

                <li>{i18n('charity_donation_process_step4')}</li>

                <li>{i18n('charity_donation_process_step5')}</li>

                {isCountryCodeUS && (
                  <li>{i18n('charity_donation_process_step6')}</li>
                )}
              </ol>
            </BodyText>
          </Row>
        </article>
      </Sheet>
    )
  }
}

export default cssModules(CharityDetailsModal, styles, { allowMultiple: true })
